import { Link } from 'react-router';
import { Bot, Vote, BarChart3, ArrowRight, TrendingUp } from 'lucide-react';
import { useVotingStats } from '@/api';

const QUICK_LINKS = [
  { path: '/admin/characters', label: 'Manage Characters', icon: Bot, desc: 'Create and edit AI characters' },
  { path: '/admin/voting', label: 'Voting Management', icon: Vote, desc: 'Toggle voting, finalize results' },
  { path: '/admin/analytics', label: 'Analytics', icon: BarChart3, desc: 'View usage and revenue' },
];

export function AdminDashboardPage() {
  const { data: votingData } = useVotingStats();
  const votingCount = votingData?.data?.characters?.length ?? 0;

  return (
    <div>
      <h1 className="font-['Poppins',sans-serif] text-4xl font-semibold text-white mb-3">
        Dashboard
      </h1>
      <p className="text-lg text-[#9595a5] mb-10">Admin overview</p>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
        <div className="p-6 rounded-xl bg-gradient-to-br from-[#18181f] to-[#1a1a22] border border-white/[0.08]">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center">
              <Vote className="w-6 h-6 text-white" />
            </div>
            <TrendingUp className="w-5 h-5 text-white/60" />
          </div>
          <div className="text-3xl font-bold text-white mb-1">{votingCount}</div>
          <div className="text-sm text-[#9595a5]">In voting</div>
        </div>
      </div>

      {/* Quick links */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {QUICK_LINKS.map(({ path, label, icon: Icon, desc }) => (
          <Link
            key={path}
            to={path}
            className="group block p-6 rounded-xl bg-[#18181f] border border-white/[0.08] hover:border-white/[0.15] transition-all duration-200"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center">
                <Icon className="w-6 h-6 text-white" />
              </div>
              <ArrowRight className="w-5 h-5 text-[#9595a5] group-hover:text-white group-hover:translate-x-1 transition-all" />
            </div>
            <h3 className="font-['Poppins',sans-serif] text-lg font-semibold text-white mb-2">{label}</h3>
            <p className="text-sm text-[#9595a5]">{desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
